import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { Request } from "src/app/parametrage/core/model/request";
import { Individual } from 'src/app/parametrage/core/model/individual/individual';
import { IndividualService } from 'src/app/parametrage/core/service/individual.service';
import { UrlTrackingService } from 'src/app/core/services/utils/url-tracking-service';

@Component({
  selector: "app-dossier-info",
  templateUrl: "./dossier-info.component.html",
  styleUrls: ["./dossier-info.component.scss"],
})
export class DossierInfoComponent implements OnInit {
  requestId: string;
  dossier: Request;

  WorkflowCategory: string = "PARTICULIER";

  individual:Individual;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _requestService: RequestService,
    private _individualService: IndividualService,
    private _urlTrackingService: UrlTrackingService
  ) {}

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.requestId = params["requestId"];
      this.getRequestById(this.requestId);
      this.getIndividualByRequestId(this.requestId);
    });
  }

  getRequestById(requestId) {
    this._requestService.getRequestById(requestId).subscribe(
      (data) => {
        if (
          data &&
          data.workflow &&
          data.workflow.categorie == this.WorkflowCategory
        ) {
          this.dossier = data;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }
  
  
  getIndividualByRequestId(requestId)
  {
    this._individualService.getIndividualByRequestId(requestId)
    .subscribe(
        data => {
          this.individual =  data;
        },
        error => {
          console.log(error);
        });
  }

  precedent(){
    const currentURL = this._urlTrackingService.getCurrentUrl();
    const previousURL = this._urlTrackingService.getPreviousUrl();
    debugger
    this._router.navigate([previousURL]);
  }


}
